/** Frontline display depth layers (Phaser setDepth). */
export const FlDepth = {
  board: 1,
  hq: 3,
  preview: 5,
  /** Full-HP unit body (+rig). Band [10, 13) used for Y-sort. */
  unitIdle: 10,
  /** Damaged unit body. Band [14, 17) used for Y-sort. */
  unitActive: 14,
  /** Level badge + HP bars (always above all unit/HQ bodies). */
  unitChrome: 18,
  /** Particles / bolt trails. */
  fx: 20,
  /** Damage / heal float text. */
  float: 30,
  hud: 40,
} as const;

/** Width of idle/active Y-sort bands (must not overlap each other or chrome). */
export const FL_BODY_Y_BAND = 3;

export type FlDepthKey = keyof typeof FlDepth;

/** Ordering invariant for tests / docs. */
export function flDepthOrdered(): number[] {
  return [
    FlDepth.board,
    FlDepth.hq,
    FlDepth.preview,
    FlDepth.unitIdle,
    FlDepth.unitActive,
    FlDepth.unitChrome,
    FlDepth.fx,
    FlDepth.float,
    FlDepth.hud,
  ];
}

/** Body depth within idle/active band; front-row (higher y) draws on top. */
export function flBodyDepth(
  base: typeof FlDepth.unitIdle | typeof FlDepth.unitActive,
  y: number,
  originY: number,
  boardH: number,
): number {
  const h = Math.max(1, boardH);
  const yNorm = Math.max(0, Math.min(1, (y - originY) / h));
  return base + yNorm * FL_BODY_Y_BAND;
}
